import { clearFilterParams } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../utils/apollo/api'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Profiles($search: String, $filter: ProfileFilter) {
    profiles(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

const SelectAllProfilesLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={accountsClient}
      {...props}
    />
  )
}

export default SelectAllProfilesLink
